import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const NoPermissionsPage = () => {
  const { logout } = useAuth();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh', padding: '2rem' }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        padding: '3rem 2.5rem',
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 1.5rem',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4a6cf7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, color: '#111827', marginBottom: '0.75rem' }}>
          No access configured
        </h2>
        <p style={{ color: '#4b5563', lineHeight: 1.6, marginBottom: '2rem' }}>
          Your account has been created but you have not been granted access to any hotel chains or properties yet.
          Please contact your administrator to have access assigned.
        </p>
        <button
          onClick={logout}
          style={{
            padding: '0.5rem 1.5rem',
            background: '#f3f4f6',
            border: '1px solid #e5e7eb',
            borderRadius: 6,
            color: '#374151',
            fontWeight: 500,
            cursor: 'pointer',
            fontSize: '0.875rem',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default NoPermissionsPage;
